import { Stack, useTheme } from "@bps/fluent-ui";
import { SoftwarePackageVersion } from "@libs/api/gateways/field/field-ops-gateway.dtos";

interface SoftwarePackageDetailsCardProps {
  softwarePackageVersion?: SoftwarePackageVersion;
}

interface DetailRowProps {
  label: string;
  value?: string;
}

const DetailRow = ({ label, value }: DetailRowProps) => {
  return (
    <Stack horizontal tokens={{ childrenGap: 8 }}>
      <strong>{label}:</strong>
      <span>{value || "--"}</span>
    </Stack>
  );
};

export const SoftwarePackageDetailsCard = ({
  softwarePackageVersion
}: SoftwarePackageDetailsCardProps) => {
  const theme = useTheme();

  return (
    <Stack
      styles={{
        root: {
          border: `1px solid ${theme.palette.neutralLight}`,
          borderRadius: 4,
          padding: theme.spacing.m,
          width: "fit-content",
          maxWidth: "100%"
        }
      }}
      tokens={{ childrenGap: theme.spacing.s1 }}
    >
      <Stack horizontal tokens={{ childrenGap: theme.spacing.l1 }}>
        <Stack grow tokens={{ childrenGap: theme.spacing.s1 }}>
          <DetailRow
            label="Display Name"
            value={softwarePackageVersion?.softwarePackageDisplayName}
          />

          <DetailRow
            label="Software Package Code"
            value={softwarePackageVersion?.softwarePackageCode}
          />

          <DetailRow
            label="Description"
            value={softwarePackageVersion?.softwarePackageDescription}
          />

          <DetailRow
            label="Type Code"
            value={softwarePackageVersion?.softwarePackageTypeCode}
          />

          <DetailRow
            label="Publisher Code"
            value={softwarePackageVersion?.softwarePublisherCode}
          />

          <DetailRow
            label="Publisher Display Name"
            value={softwarePackageVersion?.softwarePublisherDisplayName}
          />

          <DetailRow
            label="Publisher Description"
            value={softwarePackageVersion?.softwarePublisherDescription}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
